import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { api } from '../utils/api';

export function ProtectedRoute({ children, requireRole }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if profile completion is required (only for students)
  const roles = typeof user.roles === 'string' ? JSON.parse(user.roles) : user.roles;
  const isStudent = roles.includes('student') && !roles.includes('admin') && !roles.includes('lecturer');

  if (!user.is_profile_complete && isStudent) {
    return <Navigate to="/complete-profile" replace />;
  }

  // Check if user has required role
  if (requireRole) {
    const roles = typeof user.roles === 'string' ? JSON.parse(user.roles) : user.roles;
    const hasRequiredRole = Array.isArray(requireRole)
      ? requireRole.some(role => roles.includes(role))
      : roles.includes(requireRole);

    if (!hasRequiredRole) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-cyan-50 to-emerald-50">
          <div className="text-center p-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4">
              <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <h1 className="text-4xl font-bold text-red-600 mb-2">Akses Ditolak</h1>
            <p className="mt-4 text-gray-600">Anda tidak memiliki izin untuk mengakses halaman ini.</p>
            <a href="/" className="mt-6 inline-block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition shadow-lg">
              Kembali ke Dashboard
            </a>
          </div>
        </div>
      );
    }
  }

  return children;
}
